/**
 * Product Bundles JS
 * Bundle selection + one-time / subscription purchase toggle.
 * The toggle decides both the prices shown and whether a selling_plan
 * is sent with the add-to-cart.
 */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    initProductBundles();
  });

  function money(n) {
    return '$' + (Math.round(n * 100) / 100).toFixed(2);
  }

  function currentMode(container) {
    return container.dataset.purchaseMode === 'onetime' ? 'onetime' : 'subscription';
  }

  // Repaint every card's price/savings/compare for the active purchase mode
  function renderPrices(container) {
    var onetime = currentMode(container) === 'onetime';
    container.querySelectorAll('.bundle-card').forEach(function(card) {
      var price = parseFloat(onetime ? card.dataset.onetimePrice : card.dataset.price) || 0;
      var savings = parseFloat(onetime ? card.dataset.onetimeSavings : card.dataset.savings) || 0;
      var compare = parseFloat(card.dataset.comparePrice) || 0;

      var priceEl = card.querySelector('.bundle-card__price');
      var savingsEl = card.querySelector('.bundle-card__savings-amount');
      var compareEl = card.querySelector('.bundle-card__compare-price');

      if (priceEl) priceEl.textContent = money(price);
      if (savingsEl) savingsEl.textContent = money(savings > 0 ? savings : 0);
      if (compareEl) {
        if (compare > price) {
          compareEl.textContent = money(compare);
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.setAttribute('hidden', '');
        }
      }
    });
  }

  // Keep the "entrega cada N semanas" note in step with the chosen bundle
  function renderWeeks(container) {
    var selected = container.querySelector('.bundle-card--selected');
    var weeksEl = container.querySelector('[data-subscription-weeks]');
    if (selected && weeksEl) weeksEl.textContent = selected.dataset.weeks;
  }

  function setMode(container, mode) {
    container.dataset.purchaseMode = mode;
    container.querySelectorAll('.purchase-type__option').forEach(function(opt) {
      var on = opt.dataset.purchaseType === mode;
      opt.classList.toggle('purchase-type__option--selected', on);
      opt.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    renderPrices(container);
    var selected = container.querySelector('.bundle-card--selected');
    if (selected) syncToProductForm(selected);
  }

  function initProductBundles() {
    var bundlesContainers = document.querySelectorAll('.product-bundles');

    bundlesContainers.forEach(function(container) {
      var bundleCards = container.querySelectorAll('.bundle-card');
      var bundleIndexInput = container.querySelector('#bundle-index');

      // Bundle card selection
      bundleCards.forEach(function(card) {
        card.addEventListener('click', function() {
          bundleCards.forEach(function(c) { c.classList.remove('bundle-card--selected'); });
          card.classList.add('bundle-card--selected');

          var index = card.dataset.bundleIndex;
          if (bundleIndexInput) bundleIndexInput.value = index;

          renderWeeks(container);
          syncToProductForm(card);
        });
      });

      // Purchase type toggle
      container.querySelectorAll('.purchase-type__option').forEach(function(opt) {
        opt.addEventListener('click', function() {
          setMode(container, opt.dataset.purchaseType);
        });
      });

      renderPrices(container);
      renderWeeks(container);

      // Initialize sync for default selected bundle
      var initialSelected = container.querySelector('.bundle-card--selected');
      if (initialSelected) {
        syncToProductForm(initialSelected);
      }
    });
  }

  function syncQty(card, form) {
  var q = parseInt(card && card.dataset ? card.dataset.qty : 1) || 1;
  var qi = form.querySelector('input[name="quantity"]');
  if (!qi) { qi = document.createElement('input'); qi.type = 'hidden'; qi.name = 'quantity'; form.appendChild(qi); }
  qi.value = q;
}

function syncToProductForm(card) {
    var productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;
    syncQty(card, productForm);

    var variantId = card.dataset.variantId;
    var sellingPlanId = card.dataset.sellingPlanId;

    // Update variant ID
    var idInput = productForm.querySelector('input[name="id"]');
    if (idInput && variantId) {
      idInput.value = variantId;
    }

    var container = card.closest('.product-bundles');
    var onetime = container && container.dataset.purchaseMode === 'onetime';

    var sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
    if (onetime || !sellingPlanId) {
      // One-time purchase: the selling_plan must not be submitted at all
      if (sellingPlanInput) sellingPlanInput.parentNode.removeChild(sellingPlanInput);
    } else {
      if (!sellingPlanInput) {
        sellingPlanInput = document.createElement('input');
        sellingPlanInput.type = 'hidden';
        sellingPlanInput.name = 'selling_plan';
        productForm.appendChild(sellingPlanInput);
      }
      sellingPlanInput.value = sellingPlanId;
    }
  }

  // Handle upsell checkbox for adding guide product
  document.addEventListener('DOMContentLoaded', function() {
    var upsellCheckbox = document.querySelector('.upsell-checkbox');
    var productForm = document.querySelector('form[action*="/cart/add"]');

    if (upsellCheckbox && productForm) {
      productForm.addEventListener('submit', function(e) {
        if (upsellCheckbox.checked) {
          e.preventDefault();
          // Mark as handled so theme.js doesn't double-submit
          productForm.dataset.drawerHandled = 'true';

          var mainVariantId = productForm.querySelector('input[name="id"]').value;
          var qtyInput = productForm.querySelector('input[name="quantity"]');
          var mainQty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
          var sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
          var sellingPlanId = sellingPlanInput ? sellingPlanInput.value : null;
          var upsellVariantId = upsellCheckbox.dataset.variantId;

          var items = [
            { id: parseInt(mainVariantId), quantity: mainQty }
          ];

          if (sellingPlanId) {
            items[0].selling_plan = parseInt(sellingPlanId);
          }

          if (upsellVariantId) {
            items.push({ id: parseInt(upsellVariantId), quantity: 1 });
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          })
          .then(function(response) { return response.json(); })
          .then(function() {
            delete productForm.dataset.drawerHandled;
            // Open cart drawer instead of navigating
            if (window.openCartDrawer) {
              window.openCartDrawer();
            } else if (window.Swypy && window.Swypy.CartDrawer) {
              window.Swypy.CartDrawer.open();
            }
          })
          .catch(function(err) {
            console.error('Cart add error:', err);
            delete productForm.dataset.drawerHandled;
          });
        }
      });
    }
  });

  // Expose for external access
  window.ProductBundles = {
    getSelected: function(containerId) {
      var container = document.getElementById(containerId);
      if (!container) return null;

      var selectedCard = container.querySelector('.bundle-card--selected');

      return {
        bundleIndex: selectedCard ? selectedCard.dataset.bundleIndex : 0,
        price: selectedCard ? parseFloat(selectedCard.dataset.price) : 0,
        weeks: selectedCard ? selectedCard.dataset.weeks : 4,
        variantId: selectedCard ? selectedCard.dataset.variantId : null,
        sellingPlanId: selectedCard ? selectedCard.dataset.sellingPlanId : null
      };
    }
  };
})();

// Relocate the bundle section into the product buy box (before the ATC form)
function lvRelocateBundles() {
  var bundles = document.querySelector('.product-bundles');
  var form = document.querySelector('.product__info form[action*="/cart/add"], .product__info-container form[action*="/cart/add"], form[action*="/cart/add"]');
  if (!bundles || !form) return;
  var info = form.closest('.product__info, .product__info-container, .product__details');
  if (!info) return;
  var section = bundles.closest('.shopify-section') || bundles;
  section.style.margin = '0';
  bundles.style.maxWidth = 'none';
  bundles.style.padding = '0';
  form.parentNode.insertBefore(section, form);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', lvRelocateBundles);
} else {
  lvRelocateBundles();
}
